export default "__VITE_ASSET__DCAZq05N__"